
<template>
  <div class="power-tip" v-show="tipText">
    <div class="usage-tip"><i class="iconfont icona-lujing13425"></i>本次导出将消耗：<span class="tip-text" v-html="tipText"></span></div>
    <div class="remain-tip">
      <div class="title">我的权益</div>
      <div class="content">
        <div class="pop" v-html="remainText">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    watermark: {
      type: Object,
      default () {
        return {};
      }
    },
    pixel: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      tipText: ''
    }
  },
  computed: {
    ...mapGetters([
      'isEenterprise',
      'isSolo',
      'isTmpSolo',
      'isPoor',
      'UserMsg'
    ]),
  },
  watch: {
    watermark: {
      deep: true,
      handler () {
        this.init();
      }
    },
    pixel: {
      deep: true,
      handler () {
        this.init();
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    init () {
      this.tipText = this.createTipText();
      this.remainText = this.createRemainText();
    },
    createTipText() {
      // const types = {
      //   watermarkRemoval: '无水印',
      //   watermarkCustom: '自定义水印',
      //   '480p': '480P导出',
      //   '720p': '720P导出',
      //   '1080p': ''
      // };
      const {
        nonWatermark,
        nonWatermarkRemain,
        updateWatermark,
        updateWatermarkRemain,
        transformRemain
      } = this.UserMsg;
      const one = `<span style="color: #5778fb">1</span>`;
      const texts = [];
      let wText = '';
      const shouldAddWatermarkText = nonWatermarkRemain < 99 && (this.watermark.none || this.watermark.custom);
      if (shouldAddWatermarkText) {
        wText = `无水印/自定义水印 ${one} 次`;
      }
      let text = '';
      if (this.isEenterprise && transformRemain < 99 && this.pixel['1080p']) {
        text = `1080P导出${one}次`;
      } else if (this.isTmpSolo || this.isPoor) {
        text = this.pixel['720p'] ? `720P导出 ${one} 次` : '';
      } else {
        // text = `480P导出 ${one} 次。`
      }
      wText && texts.push(wText);
      text && texts.push(text);
      if (texts.every(v => !v)) {
        return '';
      }
      if (texts.length) {
        text = texts.join('，') + '。';
      }
      return text;
    },
    createRemainText() {
      const {
        nonWatermark,
        nonWatermarkRemain,
        updateWatermark,
        updateWatermarkRemain,
        transformRemain
      } = this.UserMsg;
      let wText = '';
      const shouldAddWatermarkText = nonWatermarkRemain < 99 && (this.watermark.none || this.watermark.custom);
      if (shouldAddWatermarkText) {
        wText = `<div>无水印/自定义水印： ${nonWatermarkRemain} 次</div>`;
      }
      let text = '';
      if (this.isEenterprise && transformRemain < 99) {
        text = `<div>1080P导出： ${transformRemain} 次</div>`;
      } else if (this.isTmpSolo || this.isPoor) {
        text = `<div>720P导出： ${transformRemain} 次</div>`
      } else {
        // text = `480P导出： ${transformRemain} 次`
      }
      text = wText + text;
      return text;
    }
  }
}
</script>

<style lang="scss">
.power-tip {
  display: flex;
}
.usage-tip {
  .iconfont {
    margin-right: 6px;
    color: #5778fb;
  }
}
.remain-tip {
  position: relative;
  .title {
    color: #000;
    height: 16px;
    border-bottom: 1px solid #000;
    padding-bottom: 2px;
    font-size: 12px;
  }
  & .content {
    display: none;
    position: absolute;
    left: 50%;
    transform: translatex(-50%);
    bottom: 100%;
    padding-bottom: 14px;
  }
  &:hover .content {
    display: block;
  }
  .pop {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    min-width: 111px;
    min-height: 40px;
    background: #F8F8F8;
    box-shadow: 0px 2px 3px 1px rgba(0, 0, 0, 0.10196078431372549);
    border-radius: 4px 4px 4px 4px;
    padding: 10px;
    font-size: 12px;
    color: #666;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/exportDialog/powerTip.vue